import { useState } from "react";

import { TestLibraryPanel } from "./TestLibraryPanel";
import { TestBuilderPanel } from "./TestBuilderPanel";
// BACK, 2026-09-20. It was removed on 2026-08-22 when the static
// application form replaced the dynamic engine as step one, and kept on
// disk against "a second, exam-specific question set" -- which the video
// screening round now is. The pool it edits is partitioned by round, so
// the reporting exam is unaffected by anything written here.
import { QuestionLibraryPanel } from "./QuestionLibraryPanel";

type SubView = "tests" | "library" | "questions";

const SUB_VIEWS: { key: SubView; label: string; cy: string }[] = [
  { key: "tests", label: "Tests", cy: "tests-sub-tests" },
  { key: "library", label: "Case library", cy: "tests-sub-library" },
  { key: "questions", label: "Questions", cy: "tests-sub-questions" },
];

/**
 * Admin → Tests.
 *
 * Two sub-views behind one tab, matching how AdminPage already does
 * tabbing (local state, not routes) so the admin console keeps one
 * navigation model rather than growing a second.
 */
export function TestsPanel() {
  const [view, setView] = useState<SubView>("tests");

  return (
    <div data-cy="tests-panel">
      <div className="mb-5 flex gap-1 border-b border-border">
        {SUB_VIEWS.map((v) => (
          <button
            key={v.key}
            type="button"
            data-cy={v.cy}
            onClick={() => setView(v.key)}
            className={[
              "-mb-px border-b-2 px-4 py-2 text-sm transition-colors",
              view === v.key
                ? "border-accent font-semibold text-accent"
                : "border-transparent text-foreground-muted hover:text-foreground",
            ].join(" ")}
          >
            {v.label}
          </button>
        ))}
      </div>

      {view === "tests" && <TestBuilderPanel />}
      {view === "library" && <TestLibraryPanel />}
      {view === "questions" && <QuestionLibraryPanel />}
    </div>
  );
}
